function initSuppliersCarousel(root) {
  const carousel = root.matches?.('.suppliers-carousel') ? root : root.querySelector('.suppliers-carousel')
  if (!carousel || carousel.dataset.carouselReady === 'true') return

  const track = carousel.querySelector('[data-carousel-track]')
  const prevButton = carousel.querySelector('[data-carousel-prev]')
  const nextButton = carousel.querySelector('[data-carousel-next]')
  const frame = carousel.querySelector('.suppliers-carousel__frame')

  if (!track || !prevButton || !nextButton) return

  const items = Array.from(track.children)
  if (!items.length) return

  carousel.dataset.carouselReady = 'true'
  let current = 0

  const visibleCount = () => window.matchMedia('(min-width: 750px)').matches ? 3 : 1
  const maxIndex = () => Math.max(0, items.length - visibleCount())

  const render = () => {
    current = Math.min(current, maxIndex())
    const cardWidth = items[0].getBoundingClientRect().width
    track.style.transform = `translate3d(-${current * cardWidth}px, 0, 0)`
  }

  const goNext = () => {
    current = current >= maxIndex() ? 0 : current + 1
    render()
  }

  const goPrev = () => {
    current = current <= 0 ? maxIndex() : current - 1
    render()
  }

  nextButton.addEventListener('click', goNext)
  prevButton.addEventListener('click', goPrev)

  if (frame) {
    let touchStartX = 0
    let touchStartY = 0
    frame.addEventListener('touchstart', (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) return
      touchStartX = event.touches[0].clientX
      touchStartY = event.touches[0].clientY
    }, { passive: true })
    frame.addEventListener('touchend', (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches || !touchStartX || event.changedTouches.length !== 1) return
      const dx = event.changedTouches[0].clientX - touchStartX
      const dy = event.changedTouches[0].clientY - touchStartY
      touchStartX = 0
      touchStartY = 0
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return
      if (dx < 0) goNext()
      else goPrev()
    }, { passive: true })
  }

  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(render, 80)
  })

  render()
}

initSuppliersCarousel(document)

document.addEventListener('shopify:section:load', (event) => {
  const carousel = event.target.querySelector('.suppliers-carousel')
  if (carousel) {
    carousel.dataset.carouselReady = 'false'
    initSuppliersCarousel(carousel)
  }
})
